/* Hızlı Sipariş — "Hemen satın alın" butonunu yakalar, kısa formla bilgileri toplar
   ve Shopify ödeme sayfasını bilgiler dolu olarak açar (cart permalink). */
(function () {
  if (window.__hsLoaded) return;
  window.__hsLoaded = true;

  var root = document.getElementById('hs-root');
  if (!root) return;

  var form = document.getElementById('hs-form');
  var ilSel = form.elements.il;
  var ilceSel = form.elements.ilce;
  var errEl = document.getElementById('hs-err');
  var goBtn = document.getElementById('hs-go');
  var productEl = document.getElementById('hs-product');
  var STORE_KEY = 'hs_v1';
  var ctx = null;          // { variantId, quantity }
  var dataPromise = null;  // il/ilçe verisi
  var ilceByCode = {};
  var lastFocus = null;

  function tr(a, b) { return a.localeCompare(b, 'tr'); }

  function loadData() {
    if (dataPromise) return dataPromise;
    // Biçim: "Adana:Aladağ,Ceyhan,...;Adıyaman:..." (81 il, 973 ilçe)
    dataPromise = fetch(root.dataset.ililce).then(function (r) {
      if (!r.ok) throw new Error('veri');
      return r.text();
    }).then(function (txt) {
      var names = [];
      txt.trim().split(';').forEach(function (row) {
        var i = row.indexOf(':');
        var il = row.slice(0, i);
        names.push(il);
        ilceByCode[il] = row.slice(i + 1).split(',');
      });
      names.sort(tr);
      ilSel.innerHTML = '<option value="">İl seçin</option>' + names.map(function (n) {
        return '<option value="' + n + '">' + n + '</option>';
      }).join('');
    }).catch(function () {
      dataPromise = null;
      ilSel.innerHTML = '<option value="">Liste yüklenemedi, tekrar deneyin</option>';
    });
    return dataPromise;
  }

  function fillIlce(code, selected) {
    var list = (ilceByCode[code] || []).slice().sort(tr);
    if (!list.length) {
      ilceSel.disabled = true;
      ilceSel.innerHTML = '<option value="">Önce il seçin</option>';
      return;
    }
    ilceSel.disabled = false;
    ilceSel.innerHTML = '<option value="">İlçe seçin</option>' + list.map(function (n) {
      return '<option' + (n === selected ? ' selected' : '') + '>' + n + '</option>';
    }).join('');
  }

  ilSel.addEventListener('change', function () { fillIlce(ilSel.value); });

  function saved() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; }
  }
  function save(v) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(v)); } catch (e) {}
  }

  function restore() {
    var s = saved();
    if (!s) return;
    ['name', 'phone', 'email', 'adres'].forEach(function (k) {
      if (s[k] && !form.elements[k].value) form.elements[k].value = s[k];
    });
    if (s.il) {
      ilSel.value = s.il;
      fillIlce(s.il, s.ilce);
    }
  }

  function findContext(el) {
    var scope = el.closest('[id^="shopify-section"]') || document;
    var tries = [scope, document];
    for (var i = 0; i < tries.length; i++) {
      var idInput = tries[i].querySelector('form[action*="/cart/add"] [name="id"]');
      if (idInput && idInput.value) {
        var q = tries[i].querySelector('input[name="quantity"]');
        var qty = Math.max(1, parseInt(q && q.value, 10) || 1);
        return { variantId: idInput.value, quantity: qty, scope: tries[i] };
      }
    }
    return null;
  }

  function showProduct(scope) {
    var title = (document.querySelector('meta[property="og:title"]') || {}).content || '';
    var img = (document.querySelector('meta[property="og:image"]') || {}).content || '';
    var h = scope && scope.querySelector && scope.querySelector('h1, h2');
    if (h && h.textContent.trim()) title = h.textContent.trim();
    if (!title) { productEl.innerHTML = ''; return; }
    productEl.innerHTML = (img ? '<img src="' + img + '" alt="">' : '') +
      '<div><b></b><span>' + ctx.quantity + ' adet</span></div>';
    productEl.querySelector('b').textContent = title;
  }

  function open(context) {
    ctx = context;
    lastFocus = document.activeElement;
    errEl.textContent = '';
    goBtn.disabled = false;
    goBtn.textContent = 'Ödemeye Geç';
    showProduct(context.scope);
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    loadData().then(restore);
    setTimeout(function () {
      var first = ['name', 'phone'].map(function (k) { return form.elements[k]; })
        .filter(function (i) { return !i.value; })[0];
      (first || goBtn).focus();
    }, 50);
  }

  function close() {
    root.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-hs-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });

  function normPhone(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (d.indexOf('90') === 0 && d.length === 12) d = d.slice(2);
    if (d.charAt(0) === '0') d = d.slice(1);
    return /^5\d{9}$/.test(d) ? '+90' + d : null;
  }

  function mark(el, bad) { el.classList.toggle('hs-bad', !!bad); }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var f = form.elements;
    var name = f.name.value.trim().replace(/\s+/g, ' ');
    var phone = normPhone(f.phone.value);
    var email = f.email.value.trim();
    var ilName = ilSel.value ? ilSel.options[ilSel.selectedIndex].text : '';
    var ilce = ilceSel.value;
    var adres = f.adres.value.trim().replace(/\s+/g, ' ');
    var problems = [];

    mark(f.name, name.split(' ').length < 2); if (name.split(' ').length < 2) problems.push('ad ve soyad');
    mark(f.phone, !phone); if (!phone) problems.push('geçerli bir cep telefonu');
    var emailBad = email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    mark(f.email, emailBad); if (emailBad) problems.push('geçerli bir e-posta');
    mark(ilSel, !ilName); if (!ilName) problems.push('il');
    mark(ilceSel, !ilce); if (!ilce) problems.push('ilçe');
    mark(f.adres, adres.length < 3); if (adres.length < 3) problems.push('açık adres');

    if (problems.length) {
      errEl.textContent = 'Lütfen kontrol edin: ' + problems.join(', ') + '.';
      var firstBad = form.querySelector('.hs-bad');
      if (firstBad) {
        try { firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e2) { firstBad.scrollIntoView(); }
        setTimeout(function () { try { firstBad.focus({ preventScroll: true }); } catch (e3) {} }, 300);
      }
      return;
    }
    errEl.textContent = '';
    save({ name: name, phone: f.phone.value.trim(), email: email, il: ilSel.value, ilce: ilce, adres: adres });

    var parts = name.split(' ');
    var last = parts.pop();
    var first = parts.join(' ');
    var p = new URLSearchParams();
    if (email) p.set('checkout[email]', email);
    p.set('checkout[shipping_address][first_name]', first);
    p.set('checkout[shipping_address][last_name]', last);
    p.set('checkout[shipping_address][address1]', adres);
    p.set('checkout[shipping_address][city]', ilce + ' / ' + ilName);
    p.set('checkout[shipping_address][country]', 'TR');
    p.set('checkout[shipping_address][phone]', phone);
    p.set('attributes[Telefon]', phone);
    p.set('attributes[Siparis kanali]', 'Hizli Siparis'); if (f.smsizin && f.smsizin.checked) p.set('attributes[SMS izni]', 'Evet');

    goBtn.disabled = true;
    goBtn.textContent = 'Ödeme sayfası açılıyor…';
    window.location.href = '/cart/' + ctx.variantId + ':' + ctx.quantity + '?' + p.toString();
  });

  // "Hemen satın alın" (Shopify dinamik ödeme butonu) tıklamasını en başta yakala.
  var BUY_NOW = '.shopify-payment-button, [data-shopify="payment-button"], shopify-accelerated-checkout, .payment-button-container';
  window.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [e.target];
    var hit = null;
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (n && n.nodeType === 1 && n.matches && n.matches(BUY_NOW)) { hit = n; break; }
    }
    if (!hit) return;
    var context = findContext(hit);
    if (!context) return; // ürün bilgisi bulunamazsa Shopify'ın normal akışı devam eder
    e.preventDefault();
    e.stopImmediatePropagation();
    open(context);
  }, true);

  // Liste verisini boşta önceden yükle (pencere açılınca beklemesin).
  if (document.querySelector('.payment-button-container, .shopify-payment-button')) {
    if ('requestIdleCallback' in window) requestIdleCallback(loadData); else setTimeout(loadData, 2000);
  }
})();
